import React from "react";
import { BrowserRouter } from "react-router-dom";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import { getAntDesignTheme } from "./configs/themeTokens";
import ThemeSync from "./components/ThemeSync";
import "./lang";
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ConfigProvider, notification } from "antd";
import { ModalProvider } from "components/util-components/ModalService";
import { themeStore } from "stores/themeStore.store";

const mutationCache = new MutationCache({
  onError: (error, _variables, _ctx, mutation) => {
    if (mutation.options.onError) return;
    notification.error({
      message: error.message,
    });
  },
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
  mutationCache,
});

function App() {
  const { currentTheme } = themeStore();
  const mode = currentTheme || THEME_CONFIG.currentTheme;

  return (
    <div className="App">
      <BrowserRouter history={history}>
        <QueryClientProvider client={queryClient}>
          <ThemeSync />
          <ConfigProvider theme={getAntDesignTheme(mode)}>
            <ModalProvider />
            <Layouts />
          </ConfigProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
